'use strict';

var panelsStyles = {
  'fullContainer': 'body'
};

jQuery(function (t) {
  var e = t(panelsStyles.fullContainer);
  e.length === 0 && (e = t('body'));
  var r = function () {
    t('.siteorigin-panels-stretch.panel-row-style').each(function () {
      r = t(this);
      r.css({
        'margin-left': 0,
        'margin-right': 0,
        'padding-left': 0,
        'padding-right': 0
      });
      var i = r.offset().left - e.offset().left;
      var n = e.outerWidth() - i - r.parent().outerWidth();
      r.css({
        'margin-left': -i,
        'margin-right': -n,
        'padding-left': r.data('stretch-type') === 'full' ? i : 0,
        'padding-right': r.data('stretch-type') === 'full' ? n : 0
      });
      var a = r.find('> .panel-grid-cell');
      r.data('stretch-type') === 'full-stretched' && a.length === 1 && a.css({
        'padding-left': 0,
        'padding-right': 0
      });
      r.css({
        'border-left': 0,
        'border-right': 0
      });
    });
    t('.siteorigin-panels-stretch.panel-row-style').length && t(window).trigger('panelsStretchRows');
  };
  t(window).resize(r).load(r), r(), t('body').removeClass('siteorigin-panels-before-js');
});

(function ($, window, document) {

  $(function () {

    // menu tab
    (function () {
      $(document).on('click', '.menu-tab', function (e) {
        e.preventDefault();

        var menuID = $(this).attr('id');

        if (menuID === 'bar-menu') {
          $('#panel-4-6-0-2').show();
          $('#panel-4-6-0-3').hide();
          $('#panel-4-6-0-4').hide();

          $(this).addClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-food').removeClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-drinks').removeClass('active');

        }

        if (menuID === 'bar-food') {
          $('#panel-4-6-0-2').hide();
          $('#panel-4-6-0-3').show();
          $('#panel-4-6-0-4').hide();

          $(this).addClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-menu').removeClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-drinks').removeClass('active');
        }

        if (menuID === 'bar-drinks') {
          $('#panel-4-6-0-2').hide();
          $('#panel-4-6-0-3').hide();
          $('#panel-4-6-0-4').show();

          $(this).addClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-food').removeClass('active');
          $(this).parents('.cus-menu-nav').find('#bar-menu').removeClass('active');
        }
      });
    })();

    // Metaslider
    (function () {
      var metaslider330 = function ($) {
        $('#metaslider_330').addClass('flexslider'); // theme/plugin conflict avoidance
        $('#metaslider_330').flexslider({
          slideshowSpeed: 4000,
          animation: 'fade',
          controlNav: false,
          directionNav: false,
          pauseOnHover: false,
          direction: 'horizontal',
          reverse: false,
          animationSpeed: 1000,
          prevText: '&lt;',
          nextText: '&gt;',
          slideshow: true,
          swipe: true
        });
      };
      var timerMetaslider330 = function () {
        var slider = !window.jQuery ? window.setTimeout(timerMetaslider330, 100) : !jQuery.isReady ? window.setTimeout(
          timerMetaslider330, 1) : metaslider330(window.jQuery);
      };
      timerMetaslider330();
    })();

    // Global navigation SP
    (function () {

      var siteNav = {

        el: {
          $toggle: $('.js_nav-toggle'),
          $nav: $('.js_nav'),
          $navLinks: $('.js_nav .js_link'),
          $overlay: $('.js_nav-overlay')
        },

        config: {},

        init: function () {
          this.clickHandler();
          this.navClickHandler();
        },

        clickHandler: function () {
          var _this = this;

          this.el.$toggle.on('click', function (e) {
            e.preventDefault();

            // $(this).toggleClass('active');
            _this.toggleNav();
            _this.toggleOverlay();

            return 0;
          });
        },

        navClickHandler: function () {
          var _this = this;

          this.el.$navLinks.on('click', function (e) {
            e.preventDefault();

            _this.toggleNav();
            _this.toggleOverlay();

            return 0;
          });
        },

        toggleNav: function () {
          this.el.$nav.toggleClass('active');
        },

        toggleOverlay: function () {
          this.el.$overlay.toggleClass('active');
        }

      };

      if ($('.js_nav-toggle').length) {
        siteNav.init();
      }

    })();

    // Popup modal
    (function () {

      $('.reservation-link').magnificPopup({
        type: 'inline',
        preloader: false
      });

    })();

    (function () {

      $('.js_link').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var offset = $(target).offset().top;
        $('html,body').animate({
          scrollTop: offset
        }, 700);

        return 0;
      });

    })();

  });

})(window.jQuery, window, document);
